import { TicketingFormCategory } from "@simplyk/common";

import { toFiniteNumber } from "@/common/helpers/toFiniteNumber";
import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

export const isRateTaxable = (rate: Partial<RateData>, formCategory?: TicketingFormCategory): boolean => {
  if (formCategory === TicketingFormCategory.Auction) {
    return true;
  }
  const parsedAmount = toFiniteNumber(rate.amount);
  return parsedAmount === null || parsedAmount > 0 || Boolean(rate.isPayWhatYouCan);
};

export const getInheritedTaxIds = (
  previousRate: Partial<RateData> | undefined,
  formCategory?: TicketingFormCategory
): string[] => (previousRate && isRateTaxable(previousRate, formCategory) ? [...(previousRate.taxIds ?? [])] : []);
